<template>
  <v-row justify="center">
    <v-col
      cols="12"
      :md="!view?12:8"
    >
      <base-material-card icon="mdi-card-bulleted-settings-outline">
        <template v-slot:after-heading>
          <div class="title font-weight-light">
            <span class="body-1">Оператор</span>
            <v-spacer />
            <span class="body-2">{{ title }}
              <v-icon
                v-if="view && form.id!=null && ($store.state.access[16][3] || $store.state.access[16][4] && form.creator && form.creator.id == $store.state.user.id)"
                @click="$emit('change', form.id)"
              >mdi-pencil</v-icon>
              <v-icon
                v-if="change && form.id!=null"
                @click="$emit('view', form.id)"
              >mdi-eye</v-icon>
            </span>
          </div>
        </template>
        <base-material-tabs color="warning">
          <v-tab
            v-for="(tab, i) in tabs"
            :key="i"
          >
            {{ tab }}
          </v-tab>
          <v-tab-item>
            <v-row>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="form.created"
                  label="Дата создания"
                  type="date"
                  :disabled="true"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="form.number"
                  label="Системный номер"
                  :disabled="true"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-select
                  v-model="form.state"
                  label="Статус"
                  :items="select.state"
                  :disabled="view"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="form.name"
                  label="Наименование"
                  :disabled="view"
                />
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Основные реквизиты
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container class="py-0">
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="form.legal.name.full"
                          name="legal_name_full"
                          label="Полное наименование"
                          :disabled="view"
                          @input="legal_full_name_input"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-text-field
                          v-model="form.legal.ogrn"
                          name="legal_ogrn"
                          label="ОГРН"
                          :disabled="view"
                          @input="legal_ogrn_input"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-text-field
                          v-model="form.legal.ogrn_date"
                          name="legal_ogrn_date"
                          type="date"
                          label="Дата выдачи ОГРН"
                          :disabled="view"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-text-field
                          v-model="form.legal.inn"
                          name="legal_inn"
                          label="ИНН"
                          :disabled="view"
                          @input="legal_inn_input"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-text-field
                          v-model="form.legal.kpp"
                          name="legal_kpp"
                          label="КПП"
                          :disabled="view"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="form.legal.director.post"
                          name="legal_director_post"
                          label="Должность руководителя"
                          :disabled="view"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="8"
                      >
                        <v-text-field
                          v-model="form.legal.director.name"
                          name="legal_director_name"
                          label="ФИО Руководителя"
                          :disabled="view"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Банковские реквизиты
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col
                      cols="12"
                      md="8"
                    >
                      <v-text-field
                        v-model="form.requisites.bank_name"
                        name="bank"
                        color="secondary"
                        label="Банк"
                        :disabled="view"
                        @input="bank_input"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-text-field
                        v-model="form.requisites.bic"
                        color="secondary"
                        label="Бик"
                        :disabled="view"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="form.requisites.ks"
                        color="secondary"
                        label="К/с"
                        :disabled="view"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="form.requisites.rs"
                        color="secondary"
                        label="Р/с"
                        :disabled="view"
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col cols="12">
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Адресные данные
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row
                        v-for="(address,index) in form.addresses"
                        :key="'addr'+ index"
                      >
                        <v-col cols="12">
                          <v-select
                            v-model="address.type"
                            :items="select.address_type"
                            label="Тип адреса"
                            :disabled="view"
                          />
                        </v-col>
                        <v-col cols="10">
                          <v-text-field
                            v-model="address.value"
                            label="Адрес"
                            :disabled="view"
                            :name="'address' + String(address.index)"
                            @input="adress_input(address)"
                          />
                        </v-col>
                        <v-col cols="2">
                          <v-icon @click="form.addresses = form.addresses.filter(a=>a!=address)">
                            mdi-delete
                          </v-icon>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-icon @click="form.addresses.push({value: '', type: 3})">
                            mdi-plus
                          </v-icon>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Контактные телефоны
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row
                        v-for="(item, index) in form.phones"
                        :key="'ph' + index"
                      >
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-text-field
                            v-model="item.number"
                            label="Номер телефона"
                            class="purple-input"
                            :disabled="view"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          md="5"
                        >
                          <v-select
                            v-model="item.type"
                            label="Тип"
                            class="purple-input"
                            :disabled="view"
                            :items="select.phone"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          md="2"
                        >
                          <v-checkbox
                            v-model="item.main"
                            label="Основной номер"
                            class="purple-input"
                            :disabled="view"
                            @change="()=> {if (item.main) for (let x in form.phones) form.phones[x].main = false; item.main = true; if (item.main && item.type == 1) data.phone = item.number}"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          md="1"
                        >
                          <v-icon
                            large
                            @click="form.phones = form.phones.filter(a=>a!=item)"
                          >
                            mdi-minus
                          </v-icon>
                        </v-col>
                        <v-col
                          cols="12"
                          md="9"
                        >
                          <v-text-field
                            v-model="item.comment"
                            label="Комментарий"
                            class="purple-input"
                            :disabled="view"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          md="3"
                        >
                          <v-checkbox
                            v-model="item.sms"
                            label="Согласие на СМС"
                            class="purple-input"
                            :disabled="view"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-icon @click="form.phones.push({})">
                            mdi-plus
                          </v-icon>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="form.type"
                  label="Обработчик"
                  :items="select.type"
                />
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="form.agent.type"
                  label="Тип агента"
                  :items="select.agent_type"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="form.agent.operation"
                  label="Операция платежного агента"
                  :items="select.agent_operation"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                Телефоны
              </v-col>
            </v-row>
            <v-row
              v-for="(item, index) in form.agent.phones"
              :key="'phaa' + index"
            >
              <v-col
                cols="12"
                md="11"
              >
                <v-text-field
                  v-model="item.number"
                  label="Номер телефона"
                  class="purple-input"
                  :disabled="view"
                />
              </v-col>
              <v-col
                cols="12"
                md="1"
              >
                <v-icon
                  large
                  @click="form.agent.phones = form.agent.phones.filter(a=>a!=item)"
                >
                  mdi-minus
                </v-icon>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-icon @click="form.agent.phones.push({})">
                  mdi-plus
                </v-icon>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-form>
              <v-container class="py-0">
                <v-card
                  class="elevation-1"
                  text
                >
                  <v-progress-linear
                    class="ma-0"
                    color="secondary"
                    :indeterminate="loader.show"
                  />
                  <v-card-text>
                    <v-data-table
                      hide-default-footer
                      hide-default-header
                      :items="form.files"
                      :headers="table.headers"
                      no-data-text="Нет данных для отображения"
                    >
                      <template v-slot:item.save="{item}">
                        <v-icon @click="getDoc(item)">
                          mdi-content-save
                        </v-icon>
                      </template>
                      <template v-slot:item.comment="{item}">
                        <v-text-field
                          v-model="item.comment"
                          :disabled="loader.show || view"
                          label="Описание"
                        />
                      </template>
                    </v-data-table>
                  </v-card-text>
                  <v-card-actions class="grey lighten-4">
                    <v-btn
                      color="primary"
                      text
                      :disabled="loader.show || view"
                      @click="$refs.upload.click()"
                    >
                      Добавить файл
                    </v-btn>
                    <input
                      ref="upload"
                      type="file"
                      style="display: none;"
                      @change="upload"
                    >
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-form>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :items="form.attributes_keys"
                  :headers="[
                    {value: 'key', text: 'Ключ', width: 150},
                    {value: 'value', text: 'Значение', width: 300},
                  ]"
                  :footer-props="datatable_footer"
                  no-data-text="Нет данных для отображения"
                >
                  <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                    {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
                  </template>
                  <template v-slot:item.key="{item}">
                    <v-text-field
                      v-model="item.key"
                      readonly
                      @input="settings_change(item)"
                    />
                  </template>

                  <template v-slot:item.value="{item}">
                    <v-text-field
                      v-model="form.attributes[item.key]"
                      @input="settings_change(item)"
                    />
                  </template>
                </v-data-table>
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="attribute.key"
                  label="Ключ"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-btn
                  color="primary"
                  :disabled="!attribute.key"
                  @click="form.attributes_keys.push({
                    key: String(attribute.key)
                  }), form.attributes[String(attribute.key)] = '', attribute = { key: '' }"
                >
                  Добавить
                </v-btn>
              </v-col>
            </v-row>
          </v-tab-item>
        </base-material-tabs>
        <v-row>
          <v-col
            cols="12"
          >
            <v-btn
              v-if="change"
              color="primary"
              large
              min-width="100"
              class="mr-5"
              @click="save_operator"
            >
              Сохранить
            </v-btn>
            <v-btn
              v-if="create"
              color="primary"
              large
              min-width="100"
              class="mr-5"
              @click="create_operator"
            >
              Создать
            </v-btn>
            <v-btn
              color="secondary"
              large
              min-width="100"
              @click="$router.go(-1)"
            >
              Назад
            </v-btn>
          </v-col>
        </v-row>
      </base-material-card>
    </v-col>

    <v-col
      v-if="view"
      cols="12"
      md="4"
    >
      <base-material-tabs color="warning">
        <v-tab v-if="$store.state.access[3][1] || $store.state.access[3][2]">
          События
        </v-tab>
        <v-tab v-if="$store.state.access[5][1] || $store.state.access[5][2]">
          Изменения
        </v-tab>
        <v-tab-item v-if="$store.state.access[3][1] || $store.state.access[3][2]">
          <base-material-card
            class="v-card-profile"
            title="События"
          >
            <v-card-text>
              <v-list-item
                v-for="(item,index) in events"
                :key="index"
                two-line
              >
                <v-list-item-content>
                  <v-list-item-title v-if="item.type>0 && $store.state.dict.events[item.type]">
                    {{ $store.state.dict.events[item.type].name }} {{ item.start }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <span v-if="item.user">{{ item.user_item.surname }} {{ item.user_item.name }} {{ item.user_item.patronymic }}</span>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    {{ item.theme }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon
                    large
                    @click="showEvent(item)"
                  >
                    mdi-eye
                  </v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary"
                min-width="100"
                @click="showCreateEvent"
              >
                Создать
              </v-btn>
            </v-card-actions>
          </base-material-card>
        </v-tab-item>
        <v-tab-item v-if="$store.state.access[5][1] || $store.state.access[5][2]">
          <base-material-card
            class="v-card-profile"
            title="История изменений"
          >
            <v-card-text>
              <v-list-group
                v-for="(log,index) in logs"
                :key="index"
              >
                <v-list-item
                  slot="activator"
                  two-line
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $store.state.dict.log[log.type] }}
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="log.user">
                      {{ log.user.surname }} {{ log.user.name }} {{ log.user.patronymic }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      {{ log.date_text }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-card>
                  <v-row
                    align="center"
                    justify="center"
                  >
                    <pre class="ma-5"><code class="json">{{ log.diff }}</code></pre>
                  </v-row>
                </v-card>
              </v-list-group>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="success"
                width="150"
                @click="$router.push('/admin/log/list?entity=' + form.id)"
              >
                Показать все
              </v-btn>
            </v-card-actions>
          </base-material-card>
        </v-tab-item>
      </base-material-tabs>
    </v-col>
    <v-dialog
      v-model="dialog.event.show"
      scrollable
      persistent
    >
      <event-form
        :create="dialog.event.create"
        :view="dialog.event.view"
        :change="dialog.event.change"
        :data="dialog.event.data"
        :show="dialog.event.show"
        @close="dialog.event.show = false, load_events()"
      />
    </v-dialog>
  </v-row>
</template>

<script>
  import moment from 'moment'
  import $ from 'jquery'
  import suggest from '../../../libs/suggestions.min.17.12.0.dev.js'
  import { diff, addedDiff, deletedDiff, updatedDiff, detailedDiff } from 'deep-object-diff'
  import EventForm from './../EventForm'
  export default {
    components: { EventForm },
    props: ['create', 'change', 'view', 'show', 'item'],
    data: () => ({
      attribute: {
        key: null
      },
      datatable_footer: {
        itemsPerPageText: 'Показывать по',
        pageText: 'из',
        itemsPerPageAllText: 'Все',
      },
      menu: {
        from: false,
        to: false
      },
      event: {
        items: [],
        form: {
          client: '',
        },
      },
      selected: {
      },
      info: {

      },
      loader: {
        show: false,
      },
      dialog: {
        event: {
          show: false,
          item: {},
        },

      },
      events: [

      ],
      table: {
        headers: [
          {
            text: '',
            value: 'save',
          },
          {
            text: 'Название',
            value: 'name',
          },
          {
            text: 'Описание',
            value: 'comment',
          },
        ],
      },
      tabs: [
        'Основные',
        'Реквизиты',
        'Контактная информация',
        'Обработчик',
        'Агент',
        'Файлы',
        'Атрибуты'
      ],
      data: {
        phone: '',
      },
      form: {
        agent: {
          phones: []
        },
        files: [],
        type: 0,
        legal: {
          name: {
            full: '',
            short: ''
          },
          ogrn: '',
          ogrn_date: '',
          inn: '',
          kpp: '',
          okved: [],
          director: {
            name: '',
            post: ''
          },
          tax: {
            authority: '',
            system: ''
          },
        },
        phones: [],
        addresses: [
          {
            index: 1,
            value: '',
            data: {
              postal_code: '',
              region_iso_code: '',
              region_with_type: '',
              city_with_type: '',
              street_with_type: '',
            },
            type: 1,
            suggestion: false,
          },
          {
            index: 2,
            value: '',
            data: {
              postal_code: '',
              region_iso_code: '',
              region_with_type: '',
              city_with_type: '',
              street_with_type: '',
            },
            type: 2,
            suggestion: false,
          },
        ],
        requisites: {
          name: '',
          rs: '',
          ks: '',
          bic: '',
        },
        attributes: {

        },
        attributes_keys: []
      },
      logs: [],
      dict: {
        operator: {},
        insurer: {},
        phone: {
          1: 'Мобильный',
          2: 'Домашний',
        },
        address: {
          1: 'Юридический адрес',
          2: 'Фактический адрес',
        },
        file: {
          type: {
            0: 'Без типа',
            1: 'Слайдер в описании проекта',
            2: 'Договор поручительства',
            3: 'Документы проекта',
          },
        },
        event: {
          1: 'Звонок',
          2: 'SMS сообщение',
          3: 'Email сообщение',
          4: 'Встреча',
          5: 'Другое',
        },
        type: {}
      },
      select: {
        type: [
          {
            value: 0, text: 'Основной'
          },
          {
            value: 1, text: 'Монета'
          }
        ],
        state: [
          { value: 0, text: 'Доступен' },
          { value: 1, text: 'Недоступен' },
        ],
        agent_type: [],
        agent_operation: []
      },
      suggestion: {
        address: false
      },
      search: {
        client: {
          loading: false,
          text: ''
        },
      },
    }),
    computed: {
      title: {
        get: function () {
          if (this.create) return 'Создание'
          if (this.change) return 'Изменение'
          if (this.view) return 'Просмотр'
          return ''
        },
      },
    },
    watch: {
      show: function () {
        if (this.show) {
          if (this.change) {
            this.form = JSON.parse(JSON.stringify(this.item))
          }

          if (this.view) {
            this.form = JSON.parse(JSON.stringify(this.item))
          }
          if (this.create) {
            this.form = {

            }
          }
        }
      },
    },
    mounted: function () {
      for (const x in this.$store.state.dict.agent_type) {
        this.select.agent_type.push({
          value: this.$store.state.dict.agent_type[x].key,
          text: this.$store.state.dict.agent_type[x].name
        })
      }
      for (const x in this.$store.state.dict.agent_operation) {
        this.select.agent_operation.push({
          value: this.$store.state.dict.agent_operation[x].name,
          text: this.$store.state.dict.agent_operation[x].name
        })
      }
      if (this.create) {
        this.form.created = moment().format('YYYY-MM-DD')
      }
      var id = null
      if (this.item && this.item.id) id = this.item.id
      else
        if (this.$route.query.id && (this.view || this.change)) id = this.$route.query.id
      if (id) {
        this.axios.post('/api/operator/list', { id: id })
          .then(result => {
            if (!result.data.error) {
              this.form = result.data.data[0]
              if (this.form.created) this.form.created = moment(this.form.created).format('YYYY-MM-DD')
              this.form.attributes_keys = []
              for (const x in this.form.attributes) {
                this.form.attributes_keys.push({
                  key: x
                })
              }
              this.form.requisites = this.form.requisites || {}
              this.form.legal = this.form.legal || {}
              this.form.legal.name = this.form.legal.name || {}
              this.form.legal.director = this.form.legal.director || {}
              this.form.addresses = this.form.addresses || []
              this.form.phones = this.form.phones || []
              this.form.attributes = this.form.attributes || {}

              this.form.agent = this.form.agent || {
                phones: []
              }
              this.load_events()
              this.load_logs()
            }
          })
          .catch(e => {
            console.log(e)
          })
      }
    },
    methods: {
      legal_short_name_input: function (item) {
        if (!this.suggestion.legal_requisites) {
          this.suggestion.legal_requisites = true
          $('[name=legal_name_short]').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              try {
                console.log('data', data)
                this.form.legal.name.full = data.data.name.full_with_opf
                this.form.legal.name.short = data.data.name.short_with_opf
                this.form.legal.inn = data.data.inn
                this.form.legal.kpp = data.data.kpp
                this.form.legal.ogrn = data.data.ogrn
                this.form.legal.ogrn_date = data.data.ogrn_date ? moment(new Date(data.data.ogrn_date)).format('YYYY-MM-DD') : ''
                this.form.legal.okved = data.data.okveds || [data.data.okved]
                this.form.legal.director = {}
                if (data.data.management) {
                  this.form.legal.director.name = data.data.management.name
                  this.form.legal.director.post = data.data.management.post
                }
                if (data.data.address) {
                  this.form.addresses =
                    [{
                    value: data.data.address.unrestricted_value,
                    data: data.data.address.data,
                    type: 1
                  }]
                }
                this.form.tax = {}
                console.log('data_end', this.form)
              } catch (err) {
                console.log('err', err)
              }
            },
          })
        }
      },
      legal_full_name_input: function (item) {
        if (!this.suggestion.legal_requisites) {
          this.suggestion.legal_requisites = true
          $('[name=legal_name_full]').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              console.log(data)
              this.form.legal.name.full = data.data.name.full_with_opf
              this.form.legal.name.short = data.data.name.short_with_opf
              this.form.legal.inn = data.data.inn
              this.form.legal.kpp = data.data.kpp
              this.form.legal.ogrn = data.data.ogrn
              this.form.legal.ogrn_date = data.data.ogrn_date ? moment(new Date(data.data.ogrn_date)).format('YYYY-MM-DD') : ''
              this.form.legal.okved = data.data.okveds || [data.data.okved]
              this.form.legal.director = {}
              if (data.data.management) {
                this.form.legal.director.name = data.data.management.name
                this.form.legal.director.post = data.data.management.post
              }
               if (data.data.address) {
                  this.form.addresses =
                    [{
                    value: data.data.address.unrestricted_value,
                    data: data.data.address.data,
                    type: 1
                  }]
                }
              this.form.tax = {}
            },
          })
        }
      },
      legal_inn_input: function (item) {
        if (!this.suggestion.legal_requisites) {
          this.suggestion.legal_requisites = true
          $('[name=legal_inn]').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              console.log(data)
              this.form.legal.name.full = data.data.name.full_with_opf
              this.form.legal.name.short = data.data.name.short_with_opf
              this.form.legal.inn = data.data.inn
              this.form.legal.kpp = data.data.kpp
              this.form.legal.ogrn = data.data.ogrn
              this.form.legal.ogrn_date = data.data.ogrn_date ? moment(new Date(data.data.ogrn_date)).format('YYYY-MM-DD') : ''
              this.form.legal.okved = data.data.okveds || [data.data.okved]
              this.form.legal.director = {}
              if (data.data.management) {
                this.form.legal.director.name = data.data.management.name
                this.form.legal.director.post = data.data.management.post
              }
              this.form.tax = {}
            },
          })
        }
      },
      legal_ogrn_input: function (item) {
        if (!this.suggestion.legal_requisites) {
          this.suggestion.legal_requisites = true
          $('[name=legal_ogrn]').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              console.log(data)
              this.form.legal.name.full = data.data.name.full_with_opf
              this.form.legal.name.short = data.data.name.short_with_opf
              this.form.legal.inn = data.data.inn
              this.form.legal.kpp = data.data.kpp
              this.form.legal.ogrn = data.data.ogrn
              this.form.legal.ogrn_date = data.data.ogrn_date ? moment(new Date(data.data.ogrn_date)).format('YYYY-MM-DD') : ''
              this.form.legal.okved = data.data.okveds || [data.data.okved]
              this.form.legal.director = {}
              if (data.data.management) {
                this.form.legal.director.name = data.data.management.name
                this.form.legal.director.post = data.data.management.post
              }
              this.form.tax = {}
            },
          })
        }
      },
      bank_input: function (item) {
        if (!this.suggestion.requisites) {
          this.suggestion.requisites = true
          $('[name=bank]').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'BANK',
            count: 5,
            onSelect: data => {
              console.log(data)
              this.form.requisites.bank_name = data.data.name.full || data.data.name.payment
              this.form.requisites.bic = data.data.bic
              this.form.requisites.ks = data.data.correspondent_account
            },
          })
        }
      },
      adress_input: function (item) {
        if (!item.suggestion) {
          console.log('[name=address' + String(item.index) + ']')
          item.suggestion = true
          $('[name=address' + String(item.index) + ']').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'ADDRESS',
            count: 5,
            onSelect: data => {
              item.value = data.unrestricted_value
              item.data = data.data
              console.log(item)
            },
          })
        }
      },
      upload: function (event) {
        const files = event.target.files
        if (files[0]) {
          this.loader.show = true
          const data = new FormData()
          data.append('file', files[0])
          this.axios
            .post('/api/common/file/', data, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(response => {
              if (response.data.error) {
                this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              } else {
                for (const x in response.data.data) {
                  this.form.files.push(response.data.data[x])
                }

                console.log(this.form.files)
              }
              this.loader.show = false
            })
            .catch(error => {
              console.log(error)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              this.loader.show = false
            })
        }
      },
      settings_change: function (item) {
        console.log(item)
        if (item.new) {
          item.new = false
          this.form.settings.push({
            new: true,
            type: 0,
            values: []
          })
        }
      },
      get_color: function (item, type) {
        return 'white'
      },
      load_events: function () {
        this.axios.post('/api/event/list', {
          operator: this.form.id,
        })
          .then(result => {
            if (!result.data.error) {
              for (const x in result.data.data) {
                if (result.data.data[x].type > 0 && this.$store.state.dict.events[result.data.data[x].type]) result.data.data[x].color = this.$store.state.dict.events[result.data.data[x].type].color
                result.data.data[x].start = moment(result.data.data[x].date).format('DD.MM.YYYY') + ' ' + String(result.data.data[x].time).substring(0, 5)
                result.data.data[x].end = moment(result.data.data[x].date).format('YYYY-MM-DD') + ' ' + String(result.data.data[x].time).substring(0, 5)
                if (result.data.data[x].type > 0 && this.$store.state.dict.events[result.data.data[x].type]) result.data.data[x].name = this.$store.state.dict.events[result.data.data[x].type].name
              }
              this.events = result.data.data
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },
      load_logs: function () {
        this.axios.post('/api/log/list', { entity: this.form.id, limit: 5 })
          .then(result => {
            if (!result.data.error) {
              this.logs = result.data.data || []
              for (const x in this.logs) {
                this.logs[x].date_text = moment(this.logs[x].date).format('DD.MM.YYYY HH:mm')
                this.logs[x].diff = (diff(JSON.parse(this.logs[x].old), (JSON.parse(this.logs[x].change))))
              }
            }
          })
          .catch(e => {
            console.log(e)
          })
      },
      format: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },
      format_contract: function (number, date) {
        return number + '/' + moment(date).format('DDMM')
      },
      showEvent: function (event) {
        this.dialog.event.data = event
        this.dialog.event.show = true
        this.dialog.event.create = false
        this.dialog.event.change = true
        this.dialog.event.view = false
      },
      showCreateEvent: function (event) {
        this.dialog.event.data = {
          operator: this.form.id,
          operator_item: this.form,
        }
        console.log(this.dialog.event.data)
        this.dialog.event.show = true
        this.dialog.event.create = true
        this.dialog.event.change = false
        this.dialog.event.view = false
      },
      getDoc: function (item) {
        console.log(item)
        const form = $('<form>', {
          target: '_blank',
          action: '/api/common/file/get',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item.id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      open_file: function (id, item) {
        const form = $('<form>', {
          target: '_blank',
          action: '/api/common/file',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: id,
            name: 'id',
          })
        )
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item,
            name: 'name',
          })
        )
        form.appendTo('body').submit()
      },
      adress_input: function (item) {
        if (!this.suggestion.address) {
          console.log('[name=address]')
          this.suggestion.address = true
          $('[name=address]').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'ADDRESS',
            count: 5,
            onSelect: data => {
              this.form.address = data.unrestricted_value
              this.form.address_data = data.data
            },
          })
        }
      },
      create_operator: function () {
        this.axios.post('/api/operator/create', this.form)
            .then(result => {
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Данные успешно сохранены')
                this.$router.go(-1)
              } else {
                this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })
      },
      save_operator: function () {
          this.axios.post('/api/operator/save', this.form)
            .then(result => {
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Данные успешно сохранены')
                this.$router.push('/admin/operator/view?id=' + this.form.id)
              } else {
                this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })
      },
    },
  }
</script>
